import { ReactElement } from "react";
import {
	CultureResolvableMap,
	localize,
	resolveForCurrentCulture
} from "client_legacy/ndaw/culture";
import styles from "./HelpfulResourceCard.module.less";
import { Icon } from "../../Components/Icon/Icon";
import { Anchor } from "../../Components/Anchor/Anchor";
import { FormattedText } from "../../Components/FormattedText/FormattedText";

type HelpfulResourceCardProps = {
	configuration: HelpfulResourceCardConfiguration;
};

export const HelpfulResourceCard = (props: HelpfulResourceCardProps): ReactElement => {
	const {
		configuration
	} = props;

	const {
		titleKey,
		descriptionKey,
		timeInMinutes,
		urls
	} = configuration;

	return (
		<Anchor
			className={styles.root}
			href={resolveForCurrentCulture(urls)}
			target="_blank"
		>
			<p className={styles.title}>
				{localize(titleKey)}
			</p>

			<h4 className={styles.description}>
				{localize(descriptionKey)}
			</h4>

			<div className={styles.timeIndication}>
				<Icon value="book" />

				<span>
					<FormattedText
						text={localize("_AmountMin(utes)")}
						thingsToReplace={[
							{ what: "{{Amount}}", filler: timeInMinutes }
						]}
					/>
				</span>
			</div>
		</Anchor>
	);
};
HelpfulResourceCard.displayName = "HelpfulResourceCard";

export type HelpfulResourceCardConfiguration = {
	titleKey: LocalizationKey;
	descriptionKey: LocalizationKey;
	timeInMinutes: number;
	urls: CultureResolvableMap<string>;
};
